import React, { useEffect, useState } from "react";
import validator from "validator";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import Select from "react-select";
import {
  clientAdded,
  clientUpdated,
  clientGetById,
} from "../../../Redux/clientsSlice";
import { fetchCities } from "../../../Redux/citiesSlice"; // You'll need to create this slice
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

function AjouterClient() {
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>
          <i className="fas fa-check-circle"></i>
          {msg}
        </strong>,
      );
    else
      toast.error(
        <strong>
          <i className="fas fa-exclamation-circle"></i>
          {msg}
        </strong>,
      );
  };

  const dispatch = useDispatch();
  const navigate = useHistory();
  const location = useParams();

  // Input states
  const [nom, setNom] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [taxNumber, setTaxNumber] = React.useState("");
  const [email, setEmail] = React.useState(""); // Added email field
  const [cityId, setCityId] = React.useState(null); // Added cityId field
  const [id, setId] = React.useState(0);

  // Cities
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);

  // Required states
  const [nomRequired] = React.useState(true);

  // Check if we're in edit mode
  const isEditMode = !isNaN(location.id) && location.id !== undefined;

  async function submitForm(event) {
    event.preventDefault();

    var required = document.getElementsByClassName("required");
    let hasError = false;

    for (var i = 0; i < required.length; i++) {
      if (required[i] !== undefined) {
        if (document.getElementsByClassName("error")[i]) {
          document.getElementsByClassName("error")[i].innerHTML = "";
        }
        required[i].style.borderColor = "#ccc";

        // Condition required
        if (validator.isEmpty(required[i].value)) {
          required[i].style.borderColor = "red";
          if (document.getElementsByClassName("error")[i]) {
            document.getElementsByClassName("error")[i].innerHTML =
              required[i].name + " est obligatoire";
          }
          notify(2, required[i].name + " doit être non vide");
          hasError = true;
        }
      }
    }

    // Validate email if provided
    if (email && !validator.isEmail(email)) {
      notify(2, "Format d'email invalide");
      hasError = true;
    }

    if (!hasError && !validator.isEmpty(nom)) {
      const clientData = {
        name: nom,
        phone,
        address,
        taxNumber,
        email, // Added email
        cityId: cityId || undefined, // Added cityId
      };

      let action;
      if (isEditMode) {
        // Update existing client
        action = dispatch(clientUpdated({ id: location.id, ...clientData }));
      } else {
        // Create new client
        action = dispatch(clientAdded(clientData));
      }

      action.then((data) => {
        if (data.payload) {
          const successMessage = isEditMode
            ? "Modification avec succès"
            : "Insertion avec succès";
          notify(1, successMessage);
          setTimeout(async () => {
            listeClients();
          }, 1500);
        } else {
          notify(2, data.payload?.message || "Problème de connexion");
        }
      });
    }
  }

  useEffect(() => {
    // Load cities
    dispatch(fetchCities()).then((response) => {
      const citiesData = response.payload || [];
      setCities(citiesData);
      const options = citiesData.map((city) => ({
        value: city.id,
        label: city.name,
      }));
      setCityOptions(options);
    });

    if (isEditMode) {
      // Load client data for editing
      const loadClientData = async () => {
        try {
          const result = await dispatch(clientGetById(location.id));
          const clientData = result.payload;
          if (clientData) {
            setNom(clientData.name || "");
            setPhone(clientData.phone || "");
            setAddress(clientData.address || "");
            setTaxNumber(clientData.taxNumber || "");
            setEmail(clientData.email || ""); // Added email
            setCityId(clientData.cityId || null); // Added cityId
            setId(location.id);
          }
        } catch (error) {
          notify(2, "Erreur lors du chargement des données");
        }
      };

      loadClientData();
    } else {
      // Reset form for new client
      setNom("");
      setPhone("");
      setAddress("");
      setTaxNumber("");
      setEmail(""); // Reset email
      setCityId(null); // Reset cityId
      setSelectedCity(null);
      setId(0);
    }
  }, [location.id, dispatch, isEditMode]);

  // Set selected city when cities are loaded and cityId exists
  useEffect(() => {
    if (cities.length > 0 && cityId) {
      const selectedCityObj = cities.find((city) => city.id === cityId);
      if (selectedCityObj) {
        setSelectedCity({
          value: selectedCityObj.id,
          label: selectedCityObj.name,
        });
      }
    }
  }, [cities, cityId]);

  function listeClients() {
    navigate.push("/clients/list");
  }

  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Container>
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={listeClients}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  Retour à la liste
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form
                  action=""
                  className="form"
                  method=""
                  onSubmit={submitForm}
                >
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">
                        {isEditMode ? "Modifier client" : "Ajouter client"}
                      </Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>Nom* </label>
                            <Form.Control
                              value={nom}
                              placeholder="Nom du client"
                              name="Nom"
                              className="required"
                              type="text"
                              onChange={(e) => {
                                setNom(e.target.value);
                              }}
                            />
                          </Form.Group>
                          <div className="error"></div>
                          {nomRequired ? null : (
                            <label className="error">
                              Nom est obligatoire.
                            </label>
                          )}
                        </Col>
                        <Col className="pl-1" md="6">
                          <Form.Group>
                            <label>Téléphone </label>
                            <Form.Control
                              value={phone}
                              placeholder="Téléphone"
                              type="text"
                              onChange={(e) => {
                                setPhone(e.target.value);
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      {/* Added Email and City Fields */}
                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>Email </label>
                            <Form.Control
                              value={email}
                              placeholder="Email"
                              type="email"
                              onChange={(e) => {
                                setEmail(e.target.value);
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col className="pl-1" md="6">
                          <Form.Group>
                            <label>Ville </label>
                            <Select
                              placeholder="Sélectionner une ville"
                              className="react-select primary"
                              classNamePrefix="react-select"
                              value={selectedCity}
                              isClearable={true}
                              onChange={(value) => {
                                setSelectedCity(value);
                                setCityId(value ? value.value : null);
                              }}
                              options={cityOptions}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>Adresse </label>
                            <Form.Control
                              value={address}
                              placeholder="Adresse"
                              as="textarea"
                              rows={3}
                              onChange={(e) => {
                                setAddress(e.target.value);
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col className="pl-1" md="6">
                          <Form.Group>
                            <label>N° Fiscal </label>
                            <Form.Control
                              value={taxNumber}
                              placeholder="Numéro fiscal"
                              type="text"
                              onChange={(e) => {
                                setTaxNumber(e.target.value);
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      <Button
                        className="btn-fill pull-right"
                        type="submit"
                        variant="info"
                      >
                        {isEditMode ? "Mettre à jour" : "Enregistrer"}
                      </Button>
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </>
  );
}

export default AjouterClient;
